import React, { useRef, useEffect } from "react";
import { ModalContainer, ContentContainer, TitleContainer, ChildsContainer } from "./styles";

/**
 * Componente para controle
 * @param {boolean} Active visibilidade do componente
 * @param {string} Title Titulo da Modal
 * @param {ReactElements} children Elementos filhos colocado dentro da Modal
 * @returns {ReactComponentElement} 
 */ 
const CustonModal  = ({Active, Title, children}) => {
    const childs = useRef(React.Children.toArray(children));

    useEffect(() => {
        childs.current = React.Children.toArray(children);
    }, [children]);

    return(
        <ModalContainer $Active={Active}>
            <ContentContainer>
                <TitleContainer> {Title} </TitleContainer>

                {childs.current.length > 0 ?
                    <ChildsContainer>
                        {childs.current.map((child) => {
                            return child
                        })}
                    </ChildsContainer>
                :
                    <></>
                }
            </ContentContainer>
        </ModalContainer>
    )
}

export default CustonModal;